import request from '@/router/axios'
import { VUE_APP_TENANT_CODE, VUE_APP_API_CONTEXT_PATH } from '@/utils/env'

const baseUrl = VUE_APP_API_CONTEXT_PATH

export function loginByUsername( identifier, credential, code, uuid) {
  const data = {
    username:identifier,
    password:credential,
    code:code,
    uuid:uuid,
    loginClient: "1"

  }
  return request({
    url: baseUrl + '/login',
    method: 'post',
    data: data
  })
}

export function sendSms (mobile) {
  return request({
    url: baseUrl + '/mobile/sendSms/' + mobile,
    method: 'get'
  })
}

/**
 * 根据手机号登录
 */
export function loginBySocial(social, code) {
  const data = {
    mobile:social,
    code:code,
    loginClient: "1"

  }
  return request({
    url: baseUrl + '/mobile/login',
    method: 'post',
    data: data
  })
}



export function logout() {
  return request({
    url: baseUrl + '/logout',
    method: 'post'
  })
}

export function getUserInfo(token) {
  return request({
    url: baseUrl + '/getInfo',
    method: 'get'
  })
}

export function refreshToken(token) {
  return request({
    url: baseUrl + '/v1/token/refreshToken',
    headers: {
      'Authorization': token
    },
    method: 'get',
    params: {}
  })
}

export function getCodeImg() {
  return request({
    url: baseUrl + '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/login.js